export const filterFieldsType = {
  String: 'String',
  Number: 'Number',
  Boolean: 'Boolean',
  NumberArray: 'NumberArray',
};
export default {};
